import * as React from 'react';

export const MidNight = function (props) {
  const { color } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" role="img" width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M19.5 11.25V6.75M21.75 9H17.25M15 3V6M16.5 4.5H13.5M19.7522 14.8294C19.175 14.9429 18.5882 15.0001 18 15C16.6698 14.9989 15.3564 14.7032 14.1541 14.1341C12.9518 13.5651 11.8905 12.7368 11.0463 11.7088C10.2022 10.6809 9.59616 9.47868 9.27184 8.18865C8.94753 6.89863 8.91296 5.55279 9.1706 4.24781C7.86878 4.72386 6.70789 5.52025 5.79513 6.56343C4.88238 7.60661 4.24717 8.86296 3.94818 10.2165C3.64919 11.57 3.69605 12.977 4.08443 14.3076C4.47281 15.6382 5.19019 16.8495 6.17034 17.8296C7.15048 18.8098 8.36178 19.5272 9.69239 19.9155C11.023 20.3039 12.43 20.3508 13.7835 20.0518C15.137 19.7528 16.3934 19.1176 17.4365 18.2048C18.4797 17.2921 19.2761 16.1312 19.7522 14.8294Z"
        stroke={color || '#333333'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
